// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldStringOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldStringOutlined";
import AntdIcon from '../components/AntdIcon';

var FieldStringOutlined = function FieldStringOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldStringOutlinedSvg
  }));
};

FieldStringOutlined.displayName = 'FieldStringOutlined';
export default React.forwardRef(FieldStringOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FieldStringOutlined.js
// module id = 1081
// module chunks = 0